// initial state
import * as base from './base.js'
const baseName = '/admin/system/notice'

const obj = base.setBaseUrl('notice', baseName)
const a = Object.assign(obj)
export default a
